<template lang="pug">
.container
  gb-side-menu
  .content-area
    h3 パスワード変更
    .edits-card
      .input-wrappers
        label.label 現在のパスワード
        input.input(type="password",v-model="oldPassword")
      .input-wrappers
        label.label 新しいパスワード
        input.input(type="password",v-model="newPassword")
      .input-wrappers
        label.label 新しいパスワード（確認）
        input.input(type="password",v-model="confirmPassword")
      .edit-btn
        gb-button.primary(@clicked="changePassword") 変更
</template>
<script>
import util from '@/api/util'

import GbSideMenu from '@/components/organisms/GbSideMenu.vue'
import GbButton from '@/components/atoms/GbButton.vue'
import GbInput from '@/components/atoms/GbInput.vue'

export default {
  components: {
    GbSideMenu,
    GbButton,
    GbInput
  },
  data () {
    return {
      oldPassword: null,
      newPassword: null,
      confirmPassword: null
    }
  },
  beforeMount: async function () {
    const isMaintenance = (await util.checkMaintenance({type: 'admin'})).data.data.is_maintenance
    if (isMaintenance) {
      this.$swal.fire({
        html: `現在メンテナンス中です`
      }).then(() => {
        this.$router.push({ name: 'Maintenance' })
      })
    } else {
      util.createMethod('COG', 'checkSessionExpired', null)
        .then(response => {
          if (response) this.$router.push({ name: 'SignIn' })
        })
    }
  },
  methods: {
    async changePassword () {
      if (this.newPassword !== this.confirmPassword) {
        this.$swal.fire({html: `確認のパスワードが正しくありません`})
        return
      } else if (this.oldPassword === '' || this.oldPassword === null || this.oldPassword.length < 6) {
        this.$swal.fire({html: `現在のパスワードを入力してください<br>（パスワードは6文字以上で設定してください）`})
        return
      } else if (this.newPassword === '' || this.newPassword === null || this.newPassword.length < 6) {
        this.$swal.fire({html: `新しいパスワードを入力してください<br>（パスワードは6文字以上で設定してください）`})
        return
      } else if (this.confirmPassword === '' || this.confirmPassword === null || this.confirmPassword.length < 6) {
        this.$swal.fire({html: `新しいパスワード（確認）を入力してください<br>（パスワードは6文字以上で設定してください）`})
        return
      }
      try {
        const UserData = (await util.createMethod('COG', 'currentAuthenticatedUser', null))
        const COG_REQUEST_VALUE = {
          user: UserData,
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        }
        const Response = (await util.createMethod('COG', 'changePassword', COG_REQUEST_VALUE))
        if (Response === 'SUCCESS') {
          this.$swal.fire({html: `パスワードが変更されました`})
        }
      } catch (error) {
        if (error.code === 'NotAuthorizedException') {
          this.$swal.fire({html: `パスワードが正しくありません`})
        } else if (error.message) {
          this.$swal.fire({html: `${error.message}`})
        } else {
          this.$swal.fire({html: `エラーが発生しました<br>時間をおいてもう一度お試しください`})
        }
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../stylus/main.styl'
.container
  width 100vw
  height 100vh
  display flex
  flex-direction row
.edits-card
  padding 30px
  display flex
  width 40vw
  flex-direction column
  margin auto
  background-color white
.edit-btn
  margin 40px auto
.input-wrappers
  display flex
  flex-direction column
  justify-content center
  align-items stretch
  margin 16px auto
.label
  font-size 12px
  color $color-secondary
  margin 0 8px
.input
  border none
  outline none
  height 30px
  width 400px
  border-radius 4px
  margin 8px
  padding 0 8px
  background-color $color-gray
  font-size 14px
  transition-duration .2s
  &:focus
    background-color #fff
    box-shadow 0 2px 4px rgba(42, 54, 63, 0.2)
</style>



// WEBPACK FOOTER //
// src/views/ResetPassword.vue